// Mock content assets
export const mockAssets = [
  {
    id: "asset_li_codex_1",
    project_id: "proj_codex_skills",
    title: "Skills are the missing primitive of agent design",
    platform: "linkedin",
    asset_type: "social_post",
    status: "needs_review",
    skill_used: "AdamVoice",
    hook: "For three years we've been polishing prompts. The breakthrough wasn't there.",
    body: "Most teams I talk to are still tuning prompts. The real shift is treating capability as a first-class unit — a skill — with inputs, outputs, and a phase it belongs to (research, planning, generation, critique, formatting).\n\nA Codex skill isn't a wrapper. It's a contract: when to use, what to produce, what to refuse.\n\nThe operators winning this year aren't writing better prompts. They're maintaining a private skill library and letting their agents route by phase. That's the unlock.",
    cta: "If you're building agentic systems, I'm sharing the 10 skills I keep on every project. Drop a comment and I'll DM the list.",
    hashtags: ["#AI", "#Agents", "#Operators", "#Skills"],
    char_count: 612,
    char_limit: 3000,
    updated_at: "2026-01-22T14:11:00Z",
    schedule_at: null,
  },
  {
    id: "asset_x_thread_codex",
    project_id: "proj_codex_skills",
    title: "X Thread — Codex Skills Primer",
    platform: "x",
    asset_type: "thread",
    status: "draft",
    skill_used: "AdamVoice",
    hook: "Stop tuning prompts. Start writing skills. 👇",
    body: "1/ A 'skill' is a reusable instruction with a contract — inputs, outputs, when-to-use, and a phase.\n\n2/ Most prompts pretend to be a skill but skip the phase. Phase is everything. It tells the agent *when* a capability applies.\n\n3/ My 5 phases: research → planning → generation → critique → formatting. Every skill belongs to one.\n\n4/ Why does this matter? Because an agent that knows *which* skill to call at *which* phase doesn't need a smarter model — it needs better routing.\n\n5/ I published the 10 skills I keep loaded on every the workspace project — link below.",
    cta: "Bookmark this. Sharing the skill files next week.",
    hashtags: ["#AI", "#agents"],
    char_count: 654,
    char_limit: 280,
    updated_at: "2026-01-22T14:08:00Z",
    schedule_at: null,
  },
  {
    id: "asset_yts_codex",
    project_id: "proj_codex_skills",
    title: "YouTube Shorts — 'Skills > Prompts' (45s)",
    platform: "youtube_shorts",
    asset_type: "video_script",
    status: "draft",
    skill_used: "AdamVoice",
    hook: "Everyone is still tuning prompts. They're missing the real unlock.",
    body: "[0:00–0:04] HOOK: 'Stop tuning prompts. Start writing skills.'\n[0:04–0:18] PROBLEM: prompts don't scale across an agent's lifecycle.\n[0:18–0:32] SHIFT: a skill = contract + phase (research / plan / gen / critique / format).\n[0:32–0:42] PROOF: my agent picks skills by phase. Smaller models, sharper output.\n[0:42–0:45] CTA: 'Comment SKILLS and I'll send the 10 I keep loaded.'",
    cta: "Comment SKILLS",
    hashtags: ["#AI", "#shorts", "#agents"],
    char_count: 412,
    char_limit: 5000,
    updated_at: "2026-01-22T14:00:00Z",
    schedule_at: null,
  },
  {
    id: "asset_img_codex",
    project_id: "proj_codex_skills",
    title: "Cover Image Prompt — Codex Skills",
    platform: "linkedin",
    asset_type: "image_prompt",
    status: "approved",
    skill_used: "BrandImagePrompt",
    hook: "—",
    body: "Editorial photograph, dark studio backdrop, single illuminated cube etched with abstract glyphs labeled 'RESEARCH / PLAN / GENERATE / CRITIQUE / FORMAT'. Cyan rim-light, navy ambient, no people. 3:4 ratio. No text in the image.",
    cta: "—",
    hashtags: [],
    char_count: 230,
    char_limit: 1500,
    updated_at: "2026-01-22T13:48:00Z",
    schedule_at: null,
  },
  {
    id: "asset_hvac_li",
    project_id: "proj_hvac_voice",
    title: "How HVAC companies can qualify leads after hours",
    platform: "linkedin",
    asset_type: "social_post",
    status: "approved",
    skill_used: "ContractorTrust",
    hook: "Your phones ring after 6pm. Nobody picks up. That's the real reason your ad spend isn't converting.",
    body: "Most HVAC shops lose 30–40% of inbound calls outside business hours. An AI voice agent doesn't replace your CSR — it captures the ones that would've gone to voicemail.\n\nWe set this up for a regional HVAC group last quarter. Voice agent answers, qualifies (urgency, system, address), and schedules the appointment. Booked leads went from 22% to 51% in 6 weeks.\n\nIf you run a service business, your after-hours flow is the most undervalued lever you have.",
    cta: "DM me 'AFTER HOURS' if you want the playbook.",
    hashtags: ["#HVAC", "#AI", "#SmallBusiness"],
    char_count: 568,
    char_limit: 3000,
    updated_at: "2026-01-22T10:42:00Z",
    schedule_at: "2026-01-23T13:30:00Z",
  },
  {
    id: "asset_smb_li_1",
    project_id: "proj_smb_content",
    title: "AI content systems for SMBs — LinkedIn cut",
    platform: "linkedin",
    asset_type: "social_post",
    status: "scheduled",
    skill_used: "AdamVoice",
    hook: "Small businesses don't need 'an AI strategy'. They need one workflow that compounds.",
    body: "Most SMBs we work with already publish. The problem isn't volume — it's that nothing compounds.\n\nA real AI content system has three quiet pieces: a brand voice file, a skill library, and a calendar that owners actually trust. That's it. Everything else is decoration.\n\nIf you're a service business owner, start with the brand voice. The agents get 5x better the day you write down how you actually talk.",
    cta: "Reply 'VOICE' and I'll share the template I use.",
    hashtags: ["#SmallBusiness", "#AI"],
    char_count: 488,
    char_limit: 3000,
    updated_at: "2026-01-21T09:51:00Z",
    schedule_at: "2026-01-23T15:00:00Z",
  },
  {
    id: "asset_smb_x_1",
    project_id: "proj_smb_content",
    title: "AI content systems for SMBs — X cut",
    platform: "x",
    asset_type: "social_post",
    status: "scheduled",
    skill_used: "AdamVoice",
    hook: "SMBs don't need AI. They need one workflow that compounds.",
    body: "A brand voice file, a skill library, a calendar you trust. That's the whole stack.",
    cta: "Everything else is decoration.",
    hashtags: [],
    char_count: 154,
    char_limit: 280,
    updated_at: "2026-01-21T09:51:00Z",
    schedule_at: "2026-01-24T14:00:00Z",
  },
  {
    id: "asset_chatbot_vs_workflow",
    project_id: "proj_skills_thesis",
    title: "The difference between a chatbot and a real AI workflow",
    platform: "blog",
    asset_type: "blog",
    status: "draft",
    skill_used: "TechnicalExplainer",
    hook: "Most 'AI products' shipped in 2025 were chatbots in a trench coat.",
    body: "A chatbot is a UI. A workflow is an agent. The difference isn't aesthetic — it's whether the system *makes decisions* between inputs and outputs.\n\nIn this piece I lay out a four-part test: who owns the goal, who picks the skill, who critiques the draft, and who decides 'good enough'. If a human is doing more than one of those, you have a chatbot.\n\nThe operators winning quietly in 2026 are the ones who automated three of the four — and kept the last one (decision rights) firmly human.",
    cta: "Read the full thesis →",
    hashtags: [],
    char_count: 880,
    char_limit: 12000,
    updated_at: "2026-01-20T22:08:00Z",
    schedule_at: null,
  },
  {
    id: "asset_published_voice",
    project_id: "proj_hvac_voice",
    title: "Voice agents are the easiest AI win for service businesses",
    platform: "linkedin",
    asset_type: "social_post",
    status: "published",
    skill_used: "ContractorTrust",
    hook: "The cheapest, fastest AI win for a service business isn't a chatbot. It's a voice agent.",
    body: "Three reasons: it intercepts revenue you're already losing (missed calls), it doesn't require staff training, and it gets better the more you ignore it. We've put these in five HVAC and plumbing shops in the last 90 days — every one of them paid back inside 30 days.",
    cta: "DM me 'VOICE' for the setup we use.",
    hashtags: ["#HVAC", "#Plumbing", "#AI"],
    char_count: 410,
    char_limit: 3000,
    updated_at: "2026-01-18T13:00:00Z",
    schedule_at: "2026-01-18T13:00:00Z",
  },
];
